import { forwardRef } from "react";

import PropTypes from "prop-types";

import {
  activeItemCss,
  inactiveItemCss,
  itemCss,
} from "../DirectoryTabs.style";

const propTypes = {
  /**
   * The tab's id
   */
  id: PropTypes.number.isRequired,

  /**
   * The tab's title
   */
  title: PropTypes.string.isRequired,

  /**
   * This value stores which tabs is active
   */
  activeTab: PropTypes.number.isRequired,

  /**
   * A callback function to change active tab
   */
  setActiveTab: PropTypes.func.isRequired,
};

const DirectoryTabItem = forwardRef(
  ({ id, title, activeTab, setActiveTab }, ref) => {
    const handleClick = () => {
      setActiveTab(id);
    };

    return (
      <li role="presentation" css={itemCss}>
        <button
          ref={ref}
          role="tab"
          id={`tab_${id}`}
          aria-selected={id === activeTab}
          aria-controls={`tabpanel_${id}`}
          onClick={handleClick}
          css={activeTab === id ? activeItemCss : inactiveItemCss}
        >
          {title}
        </button>
      </li>
    );
  },
);

DirectoryTabItem.propTypes = propTypes;

export default DirectoryTabItem;
